/**
 * The shim object is a dirty way for fixing circular dependencies.
 * It should be used sparingly and only when there is no other way to fix the circular dependency.
 * @returns A tuple containing a proxy object and a function to initialize the object.
 */
export function createShimObject<TObjectType extends object>() {
  let obj: TObjectType | undefined = undefined;
  const proxy = new Proxy<TObjectType>({} as TObjectType, {
    get(target, prop) {
      if (obj === undefined) throw new Error('Shim object not initialized');
      return Reflect.get(obj, prop);
    },
    set(target, prop, value) {
      if (obj === undefined) throw new Error('Shim object not initialized');
      return Reflect.set(obj, prop, value);
    },
    //TODO(nibeauli): figure out if this can support the rest of Proxy traps.
  });
  function initialize(value: TObjectType) {
    obj = value;
  }
  return [proxy, initialize] as const;
}
